import { Dictionary } from '@reduxjs/toolkit'

export enum UserRoles {
  admin = 'admin',
  contentReviewer = 'content-reviewer',
  dataSpecialist = 'data-specialist',
  academicHead = 'academic-head',
  videoEditor = 'video-editor',
  videoManager = 'video-manager',
}

/**
 * Role-specific default landing pages after login.
 * Roles not listed here will be redirected to their first accessible menu item.
 */
export const roleDefaultPaths: Partial<Record<UserRoles, string>> = {
  [UserRoles.videoManager]: '/videos/packs/',
  [UserRoles.videoEditor]: '/videos/convertedVideos/',
}

// Categorized User Roles
export const userRoles = {
  superAdmins: [String(UserRoles.admin)],
  admins: [String(UserRoles.admin), String(UserRoles.academicHead)],
  users: [String(UserRoles.dataSpecialist), String(UserRoles.contentReviewer)],
  videoAdmins: [
    String(UserRoles.admin),
    String(UserRoles.videoManager),
    String(UserRoles.academicHead),
  ],
  videoUsers: [
    String(UserRoles.videoEditor),
    String(UserRoles.admin),
    String(UserRoles.videoManager),
    String(UserRoles.academicHead),
  ],
  all: [
    String(UserRoles.admin),
    String(UserRoles.academicHead),
    String(UserRoles.contentReviewer),
    String(UserRoles.dataSpecialist),
  ],
}

export interface UserActionImpl {
  type: string
  payload?: UserImpl | UsersImpl | UserPartialImpl[] | LoginImpl | LogoutImpl
}

export interface UserPartialImpl {
  id: number
  username: string
  role?: string
}

export interface UsersImpl {
  entities: Dictionary<UserPartialImpl>
  allIds: string[]
  adminIds: string[]
  reviewerIds: string[]
  specialistIds: string[]
}

export interface UserImpl {
  id: string
  name: string
  username?: string
  isVerified: Boolean
  role: UserRoles | null
  email: string
  avatar: string
  authorized: boolean
  permissions?: any
  requestedPath: string
}

export interface LoginImpl {
  phone: string
  password: string
}

export interface LogoutImpl {
  shouldCallAPI: Boolean
}

export interface UserState {
  data: UserImpl
  isLoading: boolean
  hasError: boolean
}

export interface UserState {
  data: UserImpl
  isLoading: boolean
  hasError: boolean
}
export interface UserListState {
  data: UserImpl[]
  isLoading: boolean
  hasError: boolean
}
